import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia } from "pinia";
import i18n from "./i18n";
import axios from "axios";
import { vsxIcon } from "vue-iconsax";
import { MotionPlugin } from "@vueuse/motion";
import vuetify from "./plugins/vuetify";
import "@fortawesome/fontawesome-free/css/all.css";

axios.defaults.baseURL = process.env.VUE_APP_URL;

createApp(App)
  .component("vsxIcon", vsxIcon)
  .use(MotionPlugin)
  .use(axios)
  .use(i18n)
  .use(createPinia())
  .use(router)
  .use(vuetify)
  .mount("#app");
